import { FC, ReactElement } from 'react';

import { Page } from '../../../components';
import { ConnectedBlockRenderer, ConnectedPageHelmet } from '../../../connectors';
import { AppRoute } from '../../../entities/Routing/Routing';

import './CompanyStoryPage.scss';

export const CompanyStoryPage: FC = (): ReactElement => (
    <Page className="company-story-page">
        <ConnectedPageHelmet appRoute={AppRoute.companyStory} />
        <ConnectedBlockRenderer appRoute={AppRoute.companyStory} />
    </Page>
);
